// app/javascript/controllers/moder_actions_controller.js
import { Controller } from "@hotwired/stimulus"

/**
 * Simple toggle controller for moderation action forms.
 * Shows/hides approve and reject forms inline (replaces <details> which
 * doesn't work reliably inside overflow-hidden containers).
 */
export default class extends Controller {
  static targets = ["buttons", "approveForm", "rejectForm"]

  showApprove() {
    this.hideAll()
    this.approveFormTarget.classList.remove("hidden")
    this.buttonsTarget.classList.add("hidden")
  }

  showReject() {
    this.hideAll()
    this.rejectFormTarget.classList.remove("hidden")
    this.buttonsTarget.classList.add("hidden")
  }

  hideAll() {
    if (this.hasApproveFormTarget) this.approveFormTarget.classList.add("hidden")
    if (this.hasRejectFormTarget) this.rejectFormTarget.classList.add("hidden")
    if (this.hasButtonsTarget) this.buttonsTarget.classList.remove("hidden")
  }
}
